import React from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {isBotThinkingSelector, sendMessageToBot} from "../chatbotSlice";

export const SwitchTo: React.FC = () => {

    const dispatch = useAppDispatch();
    const thinking = useAppSelector(isBotThinkingSelector);

    const sendMessage = (message: string) => {
        if (!thinking) {
            dispatch(sendMessageToBot(message));
        }
    }

    const switchToWhatsApp = () => {
        sendMessage("I want to use WhatsApp");
    }

    const switchToSMS = () => {
        sendMessage("I want to use SMS");
    }

    return <div className="flex items-center">
        <p className="font-normal text-[13px] text-gray-600 cursor-default">Switch to</p>
        <div className="mx-[12px]">
            <img src="/switch.svg" alt="SMS"/>
        </div>
        <div className="mr-[12px] hover:cursor-pointer" onClick={e => switchToWhatsApp()}>
            <img className="h-[27px]" src="/whatsapp.png" alt="WhatsApp"/>
        </div>
        <div className="hover:cursor-pointer" onClick={e => switchToSMS()}>
            <img src="/sms.svg" alt="SMS"/>
        </div>
    </div>
}
